import NextLink from 'next/link'
import { forwardRef } from 'react'

import useSessionStore from '@/stores/sessionStore'

import type { LinkProps } from './Link.types'

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
	({ className, children, href, ...props }, ref): JSX.Element => {
		const { session } = useSessionStore()

		const shouldRedirectVisitorToLoggedOutPage = !session?.user

		if (shouldRedirectVisitorToLoggedOutPage) {
			return (
				<a className={className} href={href} {...props} ref={ref}>
					{children}
				</a>
			)
		}

		return (
			<NextLink
				className={className}
				data-link
				href={href}
				locale={false}
				{...props}
				ref={ref}
			>
				{children}
			</NextLink>
		)
	}
)

Link.displayName = 'Link'

export default Link
